import { Routes } from '@angular/router';

export const decodeQueryParams = (queryParams: {
  [key: string]: string | null;
}): { [key: string]: string } => {
  const decodedParams: { [key: string]: string } = {};
  for (const [key, value] of Object.entries(queryParams)) {
    decodedParams[key] = value ? decodeURIComponent(value) : '';
  }
  return decodedParams;
};

export function shortenThaiYear(dateStr: string): string {
  const parts = dateStr.trim().split(' ');

  if (parts.length === 3) {
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    if (/^25\d{2}$/.test(year)) {
      const shortYear = year.slice(2);
      return `${day} ${month} ${shortYear}`;
    }
  }

  return dateStr;
}

export function formatNumber(value: any, numberDigit: number = 0): string {
  return isNaN(value)
    ? value
    : Number(value).toLocaleString('en-US', {
        minimumFractionDigits: numberDigit,
        maximumFractionDigits: numberDigit,
      });
}

export function toThaiNumber(input: number | string): string {
  return input.toString().replace(/\d/g, (d) => '๐๑๒๓๔๕๖๗๘๙'[+d]);
}

export function withSubMenuId(subMenuId: number, routes: Routes): Routes {
  return routes.map((route) => ({
    ...route,
    data: { ...(route.data || {}), subMenuId },
  }));
}

export function withChildMenuId(childMenuId: number, routes: Routes): Routes {
  return routes.map((route) => ({
    ...route,
    data: { ...(route.data || {}), childMenuId },
  }));
}

export function getPaddedText(
  text: string,
  minLength: number = 20,
  padding: number = 4
): string {
  const raw = text || '';
  const totalLength = minLength + padding;
  return raw.padEnd(totalLength, ' ');
}

export function getImageFormatFromBase64(
  base64Img: string
): 'JPEG' | 'PNG' | 'GIF' | 'WEBP' | 'SVG' | 'BMP' {
  const format = base64Img?.match(
    /^data:image\/(jpeg|png|gif|webp|svg\+xml|bmp)/
  )?.[1];

  switch (format) {
    case 'png':
      return 'PNG';
    case 'gif':
      return 'GIF';
    case 'webp':
      return 'WEBP';
    case 'svg+xml':
      return 'SVG';
    case 'bmp':
      return 'BMP';
    default:
      return 'JPEG';
  }
}

export function toThaiBahtText(amount: number): string {
  const digitText = [
    'ศูนย์',
    'หนึ่ง',
    'สอง',
    'สาม',
    'สี่',
    'ห้า',
    'หก',
    'เจ็ด',
    'แปด',
    'เก้า',
  ];
  const positionText = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน'];

  function convertGroupToText(numStr: string): string {
    let result = '';
    const len = numStr.length;

    for (let i = 0; i < len; i++) {
      const digit = +numStr[i];
      const pos = len - i - 1;

      if (digit === 0) continue;

      if (pos === 0 && digit === 1 && len > 1) {
        result += 'เอ็ด';
      } else if (pos === 1 && digit === 2) {
        result += 'ยี่';
      } else if (pos === 1 && digit === 1) {
        result += '';
      } else {
        result += digitText[digit];
      }

      result += positionText[pos];
    }

    return result;
  }

  function convertIntegerToText(intStr: string): string {
    let result = '';
    let groupCount = 0;

    while (intStr.length > 0) {
      let group = intStr.slice(-6);
      intStr = intStr.slice(0, -6);

      const groupText = convertGroupToText(group);
      if (groupText) {
        if (groupCount > 0) result = groupText + 'ล้าน' + result;
        else result = groupText + result;
      } else if (groupCount > 0 && result) {
        result = 'ล้าน' + result;
      }

      groupCount++;
    }

    return result || digitText[0];
  }

  const [integerPart, decimalPartRaw] = amount.toFixed(2).split('.');
  const decimalPart = parseInt(decimalPartRaw, 10);

  const bahtText = convertIntegerToText(integerPart.replace(/^0+/, ''));
  const baht = bahtText + 'บาท';

  const satang =
    decimalPart === 0
      ? 'ถ้วน'
      : convertGroupToText(decimalPartRaw.replace(/^0+/, '')) + 'สตางค์';

  return baht + satang;
}

export function getDashedLabelLine(label: string): string {
  const currentLength = label.length;
  return '.'.repeat(currentLength + 40);
}

export function getDashedLabelLineWidth(w: number, extend: number = 40): string {
  return '.'.repeat(w + extend);
}